var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-nav sidebar--nav" }, [
    _c("div", { staticClass: "sidebar-nav-body" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "author-content" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "author-img avatar-sm d-flex" }, [
            _c("img", {
              staticClass: "logo",
              staticStyle: { width: "auto", height: "80px", margin: "auto" },
              attrs: { src: _vm.cruiseBrandLogo, alt: "logo" },
            }),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-menu-wrap" }, [
        _c("ul", { staticClass: "sidebar-menu toggle-menu list-items" }, [
          _vm.panelRights["PANEL_ASIDE_MENU_SAILS"]
            ? _c(
                "li",
                { class: [_vm.activeTab === "sail" ? "page-active" : ""] },
                [
                  _c("a", { attrs: { href: _vm.basePath + "/sails" } }, [
                    _c("i", { staticClass: "la la-train mr-2 text-color-3" }),
                    _vm._v("Seferler"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.panelRights["PANEL_ASIDE_MENU_BOOKING"]
            ? _c(
                "li",
                { class: [_vm.activeTab === "booking" ? "page-active" : ""] },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.basePath + "/bookings" } }, [
                    _c("i", {
                      staticClass: "la la-address-book mr-2 text-color-7",
                    }),
                    _vm._v("Rezervasyon"),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "toggle-drop-menu" }, [
                    _vm.panelRights["PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER"]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.basePath + "/bookings?status=OK",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-address-book mr-2 text-color-7",
                              }),
                              _vm._v("Başarılı"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER"]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.basePath +
                                  "/bookings?status=PARTIALLY_PAID",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-address-book mr-2 text-color-7",
                              }),
                              _vm._v("Parçalı Ödeme"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER"]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.basePath + "/bookings?status=CANCELLED",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-address-book mr-2 text-color-7",
                              }),
                              _vm._v("İptal"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER"]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.basePath + "/bookings?status=PENDING",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-address-book mr-2 text-color-7",
                              }),
                              _vm._v("Beklemede"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights[
                      "PANEL_ASIDE_MENU_BOOKING_BOOKINGS_FILTER_COMPLIMENTARY"
                    ]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.basePath +
                                  "/bookings?status=COMPLIMENTARY",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-address-book mr-2 text-color-7",
                              }),
                              _vm._v("Ücretsiz"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_BOOKING_HISTORY"]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.basePath + "/bookings/archived",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-address-book mr-2 text-color-7",
                              }),
                              _vm._v("Geçmiş Rezervasyonlar"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_GROUP_RESERVATION"]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.basePath + "/group-reservation",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-address-book mr-2 text-color-7",
                              }),
                              _vm._v("Group Rezervasyonu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.panelRights["PANEL_ASIDE_MENU_PRICINGS"]
            ? _c(
                "li",
                {
                  class: [
                    _vm.activeTab === "price" ||
                    _vm.activeTab === "additional-price"
                      ? "page-active"
                      : "",
                    _vm.activeTab === "market" ? "active" : "",
                  ],
                },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.basePath + "/pricings" } }, [
                    _c("i", { staticClass: "la la-money mr-2" }),
                    _vm._v("Fiyatlandırmalar"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "toggle-drop-menu",
                      style:
                        _vm.activeTab === "price" ||
                        _vm.activeTab === "market" ||
                        _vm.activeTab === "additional-price"
                          ? "display: block;"
                          : "",
                    },
                    [
                      _vm.panelRights["PANEL_ASIDE_MENU_PRICINGS_PRICING"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "price" ? "page-active" : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.basePath + "/pricings" } },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-money mr-2 text-color-4",
                                  }),
                                  _vm._v("Fiyatlandırma"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights[
                        "PANEL_ASIDE_MENU_PRICINGS_ADDITIONAL_SERVICE_PRICING"
                      ]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "additional-price"
                                  ? "page-active"
                                  : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      _vm.basePath +
                                      "/additional-service/pricings",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-money mr-2 text-color-4",
                                  }),
                                  _vm._v("Ek Hizmet Fiyatlandırma"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_PRICINGS_MARKETS"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "market" ? "page-active" : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.basePath + "/markets" } },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-globe mr-2 text-color-3",
                                  }),
                                  _vm._v("Market"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.panelRights["PANEL_ASIDE_MENU_AGENCY"]
            ? _c(
                "li",
                {
                  class: [
                    _vm.activeTab === "agency-outline"
                      ? "page-active active"
                      : "",
                    _vm.activeTab === "agency-proforma" ? "page-active" : "",
                    _vm.activeTab === "agency" ? "page-active active" : "",
                  ],
                },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.basePath + "/agencies" } }, [
                    _c("i", { staticClass: "la la-book mr-2" }),
                    _vm._v("Acente"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "toggle-drop-menu",
                      style:
                        _vm.activeTab === "agency" ||
                        _vm.activeTab === "agency-proforma" ||
                        _vm.activeTab === "agency-outline"
                          ? "display: block;"
                          : "",
                    },
                    [
                      _vm.panelRights["PANEL_ASIDE_MENU_AGENCY_AGENCIES"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "agency" ? "page-active" : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.basePath + "/agencies" } },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-route mr-2 text-color-3",
                                  }),
                                  _vm._v("Acenteler"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_AGENCY_OUTLINE"] &&
                      _vm.projectName === "selectum"
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "agency-outline"
                                  ? "page-active"
                                  : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.basePath + "/agency/outline",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-anchor mr-2 text-color-3",
                                  }),
                                  _vm._v("Acente Muhasebe"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_AGENCY_PROFORMA"] &&
                      _vm.projectName === "miray"
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "agency-proforma"
                                  ? "page-active"
                                  : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.basePath + "/agency/proforma",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-anchor mr-2 text-color-3",
                                  }),
                                  _vm._v("Proforma"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_AGENCY_PROFORMA"] &&
                      _vm.projectName === "miray"
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "agency-proforma"
                                  ? "page-active"
                                  : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.basePath + "/proforma-invoices",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-anchor mr-2 text-color-3",
                                  }),
                                  _vm._v("Proforma/Fatura"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.panelRights["PANEL_ASIDE_MENU_DEFINITIONS"]
            ? _c(
                "li",
                {
                  class: [
                    _vm.activeTab === "seaTour" ? "page-active" : "",
                    _vm.activeTab === "port" ? "active" : "",
                    _vm.activeTab === "cruise" ? "active" : "",
                    _vm.activeTab === "country" ? "active" : "",
                    _vm.activeTab === "city" ? "active" : "",
                    _vm.activeTab === "district" ? "active" : "",
                  ],
                },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.basePath + "/seatours" } }, [
                    _c("i", { staticClass: "la la-book mr-2" }),
                    _vm._v("Tanımlamalar"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "toggle-drop-menu",
                      style:
                        _vm.activeTab === "seaTour" ||
                        _vm.activeTab === "port" ||
                        _vm.activeTab === "cruise" ||
                        _vm.activeTab === "country" ||
                        _vm.activeTab === "city" ||
                        _vm.activeTab === "district"
                          ? "display: block;"
                          : "",
                    },
                    [
                      _vm.panelRights["PANEL_ASIDE_MENU_DEFINITIONS_SEATOURS"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "seaTour"
                                  ? "page-active"
                                  : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.basePath + "/seatours" } },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-route mr-2 text-color-3",
                                  }),
                                  _vm._v("Tur"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_DEFINITIONS_PORTS"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "port" ? "page-active" : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.basePath + "/ports" } },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-anchor mr-2 text-color-3",
                                  }),
                                  _vm._v("Liman"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_DEFINITIONS_CRUISES"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "cruise" ? "page-active" : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.basePath + "/cruises" } },
                                [
                                  _c("i", {
                                    staticClass:
                                      "las la-ship mr-2 text-color-3",
                                  }),
                                  _vm._v("Cruises"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_DEFINITIONS_COUNTRIES"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "country"
                                  ? "page-active"
                                  : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: _vm.basePath + "/countries" },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-globe mr-2 text-color-3",
                                  }),
                                  _vm._v("Ülkeler"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_DEFINITIONS_CITIES"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "cities" ? "page-active" : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: _vm.basePath + "/cities" } },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-globe mr-2 text-color-3",
                                  }),
                                  _vm._v("Şehirler"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.panelRights["PANEL_ASIDE_MENU_DEFINITIONS_DISTRICTS"]
                        ? _c(
                            "li",
                            {
                              class: [
                                _vm.activeTab === "district"
                                  ? "page-active"
                                  : "",
                              ],
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: _vm.basePath + "/districts" },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "la la-globe mr-2 text-color-3",
                                  }),
                                  _vm._v("İlçeler"),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.panelRights["PANEL_ASIDE_MENU_REPORTS"]
            ? _c(
                "li",
                { class: [_vm.activeTab === "reports" ? "page-active" : ""] },
                [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.basePath + "/reports/1" } }, [
                    _c("i", { staticClass: "la la-chart-pie mr-2" }),
                    _vm._v("Raporlar"),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "toggle-drop-menu" }, [
                    _vm.panelRights["PANEL_ASIDE_MENU_REPORTS_DASHBOARD"]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/1" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Dashboard"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_REPORTS_FORECAST"]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/forecast" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Sefer Oda Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_REPORTS_FORECAST_REPORT"]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/161" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Forecast Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectName === "miray"
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/98" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Acenteler"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectName === "miray" &&
                    _vm.panelRights[
                      "PANEL_ASIDE_MENU_REPORTS_RESERVATION_REPORT"
                    ]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/2" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Rezervasyon Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectName === "selectum" &&
                    _vm.panelRights[
                      "PANEL_ASIDE_MENU_REPORTS_RESERVATION_REPORT"
                    ]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/3" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Rezervasyon Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectName === "selectum" &&
                    _vm.panelRights[
                      "PANEL_ASIDE_MENU_REPORTS_ROOM_AVAILABILITY"
                    ]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/4" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Oda Musaitlik"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectName === "selectum" &&
                    _vm.panelRights["PANEL_ASIDE_MENU_REPORTS_AGENCY_PAYMENTS"]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/97" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Acente Ödemeler"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights[
                      "PANEL_ASIDE_MENU_REPORTS_SAIL_RESERVATION_REPORT"
                    ]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.basePath + "/sefer-rezervasyon-raporu",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Sefer Rezervasyon Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights[
                      "PANEL_ASIDE_MENU_REPORTS_AGENCY_RESERVATION_REPORT"
                    ] && _vm.projectName === "miray"
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.basePath + "/acente-rezervasyon-raporu",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Acente Rezervasyon Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights[
                      "PANEL_PAGE_BOOKING_AGENCY_COMMISSION_RATE_REPORT"
                    ] && _vm.projectName === "miray"
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/130" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v(
                                "Acente Rezervasyon Komisyon Raporu ( Yeni )"
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights[
                      "PANEL_PAGE_BOOKING_AGENCY_COMMISSION_RATE_REPORT"
                    ]
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.basePath +
                                  "/booking-agency-commission-report",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Acente Rezervasyon Komisyon Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectName === "miray"
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/66" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Acente Kullanıcı Raporu"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectName === "selectum" &&
                    _vm.panelRights["PANEL_ASIDE_MENU_REPORTS_AGENCY_PAYMENTS"]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/reports/193" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Moka Logları"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.panelRights["PANEL_ASIDE_MENU_MANAGEMENT"]
            ? _c(
                "li",
                { class: [_vm.activeTab === "reports" ? "page-active" : ""] },
                [
                  _vm._m(7),
                  _vm._v(" "),
                  _c("a", { attrs: { href: _vm.basePath + "/roles" } }, [
                    _c("i", { staticClass: "la la-chart-pie mr-2" }),
                    _vm._v("Yönetim"),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "toggle-drop-menu" }, [
                    _vm.panelRights["PANEL_ASIDE_MENU_MANAGEMENT_ROLES"]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/roles" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Role Yetkilendirme"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.panelRights["PANEL_ASIDE_MENU_MANAGEMENT_ACCESS_LOGS"]
                      ? _c("li", [
                          _c(
                            "a",
                            { attrs: { href: _vm.basePath + "/access-logs" } },
                            [
                              _c("i", {
                                staticClass:
                                  "la la-chart-line mr-2 text-color-7",
                              }),
                              _vm._v("Erişim Logları"),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.panelRights["PANEL_ASIDE_MENU_SETTINGS"]
            ? _c(
                "li",
                { class: [_vm.activeTab === "settings" ? "page-active" : ""] },
                [
                  _c("a", { attrs: { href: _vm.basePath + "/settings" } }, [
                    _c("i", { staticClass: "la la-gear mr-2 text-color-11" }),
                    _vm._v("Ayarlar"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            { class: [_vm.activeTab === "logout" ? "page-active" : ""] },
            [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      return _vm.logout()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "la la-power-off mr-2 text-color-11",
                  }),
                  _vm._v("Çıkış"),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "side-menu-close" }, [
      _c("i", { staticClass: "la la-times" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "author-bio" }, [
      _c("span", { staticClass: "author__meta" }, [
        _vm._v("Panele Hoş Geldiniz"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "side-menu-icon toggle-menu-icon" }, [
      _c("i", { staticClass: "la la-angle-down" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "side-menu-icon toggle-menu-icon" }, [
      _c("i", { staticClass: "la la-angle-down" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "side-menu-icon toggle-menu-icon" }, [
      _c("i", { staticClass: "la la-angle-down" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "side-menu-icon toggle-menu-icon" }, [
      _c("i", { staticClass: "la la-angle-down" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "side-menu-icon toggle-menu-icon" }, [
      _c("i", { staticClass: "la la-angle-down" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "side-menu-icon toggle-menu-icon" }, [
      _c("i", { staticClass: "la la-angle-down" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }